import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Receipt, Play, Sparkles, Gift, Package } from "lucide-react";

const SOURCE_LABEL = {
  single: { label: "single", icon: Play, className: "text-hotpink" },
  bundle: { label: "bundle", icon: Package, className: "text-hotpink" },
  access_code: { label: "gift code", icon: Gift, className: "text-hotpink" },
  share_credit: { label: "shared", icon: Sparkles, className: "text-white/70" },
  share: { label: "shared", icon: Sparkles, className: "text-white/70" },
};

export default function PurchaseHistory() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/me/purchases").then((r) => setData(r.data)).catch(() => setData({ unlocks: [], total: 0 }));
  }, []);

  if (!data) return <p className="font-outfit text-white/50 text-sm">loading receipts...</p>;

  return (
    <div className="mb-10" data-testid="purchase-history">
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <Receipt className="text-hotpink" size={22} />
        <h2 className="brush-title text-3xl md:text-4xl text-white">MY <span className="text-hotpink">STASH.</span></h2>
        <span className="scribble text-hotpink text-lg ml-auto">{data.total} unlocked ♡</span>
      </div>

      {data.unlocks.length === 0 && (
        <div className="bg-coal border border-white/10 p-6 text-center">
          <p className="scribble text-white/70 text-xl mb-4">nothing here yet — go get some receipts.</p>
          <Link to="/episodes" data-testid="ph-browse-episodes" className="inline-block bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-xs px-6 py-3">
            browse episodes →
          </Link>
        </div>
      )}

      {data.unlocks.length > 0 && (
        <div className="bg-coal border border-white/10">
          <div className="grid grid-cols-[auto,1fr,auto,auto] gap-x-4 gap-y-1 items-center px-5 py-3 text-[10px] uppercase tracking-widest font-outfit text-white/40 border-b border-white/10">
            <span>Ep</span><span>Title</span><span>Source</span><span>Unlocked</span>
          </div>
          <div className="divide-y divide-white/5 max-h-[540px] overflow-y-auto">
            {data.unlocks.map((u) => {
              const meta = SOURCE_LABEL[u.source] || SOURCE_LABEL.single;
              const Icon = meta.icon;
              return (
                <div key={u.id || `${u.episode_number}-${u.created_at}`} className="grid grid-cols-[auto,1fr,auto,auto] gap-x-4 gap-y-1 items-center px-5 py-3 text-sm font-outfit" data-testid={`ph-row-${u.episode_number}`}>
                  <span className="brush-title text-2xl text-white leading-none w-8">{String(u.episode_number).padStart(2, "0")}</span>
                  <Link to="/episodes" className="text-white/90 hover:text-hotpink truncate">{u.episode_title}</Link>
                  <span className={`flex items-center gap-1 text-[10px] uppercase tracking-widest ${meta.className}`}>
                    <Icon size={11}/> {meta.label}
                  </span>
                  <span className="text-white/40 text-[10px] uppercase tracking-widest">{new Date(u.created_at).toLocaleDateString()}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
